import { AppState } from '@store/state';
import { CommonOrderModel } from './common-order.model';
import { createSelector } from '@ngrx/store';

export const stateSelect = (state: AppState): CommonOrderModel => state.commonOrderData;

export const selectCommonOrderReference = createSelector(stateSelect, ({ orderReference }: CommonOrderModel) => orderReference);
